module.exports = __webpack_public_path__ + "a06ecd333cca045615ea67f368bfacf9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/autocorrect.svg
// module id = 163
// module chunks = 0